import React from "react";
import Cookies from "universal-cookie";

const renderLangString = ({ id, variables, html }) => {
  const cookie = new Cookies();
  const lang = cookie.get("lang") || "de-DE";
  let string = languageStrings[lang][id];

  // if translation id exists
  if (string) {
    // if string contains variables
    if (variables) {
      // add variables
      Object.keys(variables).forEach(key => {
        string = string.replace(`{${key}}`, variables[key]);
      });

      // add pluralization 1 = singular, 2 plural, 0 hide value
      if ("pluralizationIndex" in variables) {
        const insideOfTheArray = string.slice(string.indexOf("[") + 1, string.indexOf("]"));
        const arr = insideOfTheArray.split(", ");
        const word = arr[variables.pluralizationIndex - 1];

        if (variables.pluralizationIndex === 0) {
          string = string.replace(`[${insideOfTheArray}]`, "");
        } else {
          string = string.replace(`[${insideOfTheArray}]`, word);
        }
      }

      // if some of the variables are not defined render empty string
      string = string.replace(/\{(.+?)\}/g, "");
    }

    // render html
    if (html) return <span dangerouslySetInnerHTML={{ __html: string }}></span>;
    return string;
  } else {
    console.error(`String id [${id}] does not exist!`);
    return languageStrings[lang]["default"];
  }
};

// call it like this
// renderLangString({
//   id: "$_l",  // sting id
//   variables: {
//     pluralizationIndex: 1,  // can be 1 || 2 || 0
//     num: 3,
//     toWhat: renderLangString({id: "$_d9"}),
//     date: "(19.10.2020 - 01:59)",
//   },
//   html: true,  // render as html
// }

// prettier-ignore
const languageStrings = {
  "en-US": {
    "default":  " - standardtext - ",
    "$_0":  "Application Logo",
    "$_1":  "Icon",
    "$_2":  "Dashboard",
    "$_3":  "Log out",
    "$_4":  "Stage",
    "$_5":  "Collection",
    "$_6":  "Active Stages",
    "$_7":  "No active stages!",
    "$_8":  "Incoming Stages",
    "$_9":  "No incoming stages!",
    "$_a":  "Expired Stages",
    "$_b":  "No expired stages!",
    "$_c":  "Starts",
    "$_d":  "Ends",
    "$_e":  "{num} [day, days] left",
    "$_f":  "{num} [collection, collections]",
    "$_g":  "in progress",
    "$_h":  "done",
    "$_i":  "Not yet started",
    "$_j":  "Expired",
    "$_k":  "Evaluation rounds",
    "$_l":  "Just <strong>{num} [Day, Days]</strong> until {toWhat} {date}",
    "$_m":  "Evaluation collection",
    "$_o":  "If you should not vote, please confirm by clicking on the button below.",
    "$_p":  "If you should vote, please confirm by clicking on the button below.",
    "$_q":  "Exclude me",
    "$_r":  "Include me",
    "$_s":  "Take it back",
    "$_t":  "Almost Done!",
    "$_u":  "All cases in this collection are confirmed! Plese review your votes and confirm the collection.",
    "$_v":  "Review Votes",
    "$_w":  "My top cases",
    "$_x":  "back",
    "$_y":  "next",
    "$_z":  "show all cases",
    "$_z1":  "hide all cases",
    "$_a1":  "All cases in this collection",
    "$_a2":  "Congratulation!",
    "$_a3":  "Collection confirmed!",
    "$_a4":  "Please review your votes and confirm the results.",
    "$_a5":  "Please click on the button below to unconfirm.",
    "$_a6":  "Confirm",
    "$_a7":  "Page menu",
    "$_a8":  "Footer menu",
    "$_a9":  "close",
    "$_b1":  "Oops! Something went wrong.",
    "$_b2":  "Our technicians are aware of the problem and are working to resolve it. We ask for your understanding!",
    "$_b3":  "Evaluation Categories",
    "$_b4":  "Reviewers in this collection",
    "$_b5":  "Logout",
    "$_b6":  "Are you sure you want to log out?",
    "$_b7":  "Cancle",
    "$_b8":  "Evaluation Rounds",
    "$_b9":  "Stage voting has expired",
    "$_c1":  "Header navigation",
    "$_c2":  "Reviewers in this stage",
    "$_c3":  "All cases in this collection",
    "$_c4":  "Total",
    "$_c5":  "[Case, Cases]",
    "$_c6":  "Categories done",
    "$_c7":  "Judges done",
    "$_c8":  "Connection lost",
    "$_c9":  "Please check your connection and reload the page.",
    "$_d1":  "Reload the page",
    "$_d2":  "Sparen...",
    "$_d3":  "Saved",
    "$_d4":  "Download",
    "$_d5":  "There are no reviewers assigned to this project.",
    "$_d6":  "Not defined",
    "$_d7":  "There are no collections in this stage.",
    "$_d8":  "There are no cases in this collection.",
    "$_d9":  "End",
    "$_e1":  "Collection was successfully confirmed.",
    "$_e2":  "Download link: {id}",
    "$_e3":  "View on new page: {value}, linkID: {id}",
    "$_e4":  "Progress bar",
    "$_e5":  "Title",
    "$_e6":  "See in gallery",
    "$_e7":  "Card view",
    "$_e8":  "Cookie Policy",

    "$_d5_1":  "Info Pages",

  },
  "de-DE": {
    "default":  " - default text - ",
    "$_0":  "Anwendungslogo",
    "$_1":  "das Ikon",
    "$_2":  "Instrumententafel",
    "$_3":  "Ausloggen",
    "$_4":  "Stufe",
    "$_5":  "Kategorie",
    "$_6":  "Aktive Bewertungsrunden",
    "$_7":  "Keine aktiven Bewertungsrunden!",
    "$_8":  "Kommende Bewertungsrunden",
    "$_9":  "Keine zukünftigen Bewertungsrunden!",
    "$_a":  "Abgelaufene Bewertungsrunden",
    "$_b":  "Keine abgelaufenen Bewertungsrunden!",
    "$_c":  "Start",
    "$_d":  "Ende",
    "$_e":  "{num} verbleibende [Tag, Tage]",
    "$_f":  "{num} [Kategorie, Kategorien]",
    "$_g":  "in Bearbeitung",
    "$_h":  "erledigt",
    "$_i":  "Noch nicht begonnen",
    "$_j":  "Abgelaufen",
    "$_k":  "Bewertungsrunden",
    "$_l":  "Nur noch <strong>{num} [Tag, Tage]</strong>",
    "$_m":  "Kategorien",
    "$_o":  "Falls Sie befangen sind, und sich von der Bewertung dieses Projekts ausschließen möchten, klicken Sie hier.",
    "$_p":  "Falls Sie Ihre Enthaltung rückgängig machen möchten, klicken Sie bitte hier.",
    "$_q":  "Ich bin bei dieser Arbeit befangen.",
    "$_r":  "Mich einbeziehen",
    "$_s":  "Zurücknehmen",
    "$_t":  "Fast fertig!",
    "$_u":  "Alle Projekte in dieser Kategorie sind bewertet! Bitte überprüfen Sie Ihre Bewertungen und bestätigen Sie die Kategorie.",
    "$_v":  "Rückblick Abstimmungen",
    "$_w":  "Meine Top-Projekte",
    "$_x":  "zurück",
    "$_y":  "weiter",
    "$_z":  "alle Projekte einblenden",
    "$_z1":  "alle Projekte ausblenden",
    "$_a1":  "Alle Projekte in dieser Kategorie",
    "$_a2":  "Herzlichen Glückwunsch!",
    "$_a3":  "Kategorie fertig!",
    "$_a4":  "Bitte überprüfen Sie Ihre Bewertungen und bestätigen Sie die Ergebnisse.",
    "$_a5":  "Bitte klicken Sie zum Bestätigen auf die Schaltfläche unten.",
    "$_a6":  "Bestätigen",
    "$_a7":  "Menü Seite",
    "$_a8":  "Fußzeilen-Menü",
    "$_a9":  "close",
    "$_b1":  "Hoppla! Etwas ist schief gelaufen.",
    "$_b2":  "Unsere Techniker wissen Bescheid und arbeiten an der Behebung des Problems. Wir bitten um Verständnis!",
    "$_b3":  "Bewertungs-Kategorie",
    "$_b4":  "Jury in dieser Kategorie",
    "$_b5":  "Abmeldung",
    "$_b6":  "Sind Sie sicher, dass Sie sich abmelden möchten?",
    "$_b7":  "Abbrechen",
    "$_b8":  "Bewertungsrunden",
    "$_b9":  "Die Zeit der Bewertungsrunde ist abgelaufen",
    "$_c1":  "Kopfzeilen-Navigation",
    "$_c2":  "Jury in dieser Phase",
    "$_c3":  "Alle Projekte in dieser Kategorie",
    "$_c4":  "Gesamt",
    "$_c5":  "[Projekt, Projekte]",
    "$_c6":  "Kategorie erledigt",
    "$_c7":  "Jurymitglieder fertig",
    "$_c8":  "Internetverbindung verloren",
    "$_c9":  "Bitte überprüfen Sie Ihre Internetverbindung und laden Sie die Seite neu.",
    "$_d1":  "Laden Sie die Seite neu",
    "$_d2":  "Speichert...",
    "$_d3":  "Gespeichert",
    "$_d4":  "Herunterladen",
    "$_d5":  "Es sind diesem Projekt keine Jurymitglieder zugeteilt.",
    "$_d6":  "Nicht definiert",
    "$_d7":  "In dieser Phase gibt es keine Kategorie.",
    "$_d8":  "Es gibt keine Projekte in dieser Kategorie.",
    "$_d9":  "Ende",
    "$_e1":  "In dieser Kategorie sind alle Projekte bewertet.",
    "$_e2":  "Download-Link: {id}",
    "$_e3":  "Auf neuer Seite anzeigen: {value}, Link-ID: {id}",
    "$_e4":  "Fortschrittsanzeige",
    "$_e5":  "Titel",
    "$_e6":  "Siehe in der Galerie",
    "$_e7":  "Kartenansicht",
    "$_e8":  "Cookie-Richtlinie",
    "$_d5_1":  "Infoseiten",
  }
};

export { renderLangString };
export default renderLangString;
